import { selectMeasurementSystem } from 'spw-redux/modules/user/selectors';
import { createSelector } from 'reselect';
import { getUnit } from './hooks';

export const selectAreaUnit = createSelector(
  selectMeasurementSystem,
  (system) => getUnit('area', { outputIsFractionUnit: false }, system)
);
